import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardBody, Form, FormGroup, Label, Row } from "reactstrap";
import { H3, Breadcrumbs } from "../../../AbstractElements";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Cancel, Save } from "../../../Constant";
import {
    getLeaveType,
    getLeaveTypeRole,
    storeLeaveType,
    storeLeaveTypeRole,
    updateLeaveType,
    updateLeaveTypeRole
} from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { postClientUrlWithToken, getClientUrlDataToken } from "../../../Utils/restUtils";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import HandleApiError from "../../Common/ErrorImport/ErrorImport";
import Button from "../../Common/Elements/Button";
import Select from 'react-select';
import Typeahead from "../../../CommonElements/TypeAhead";

const schema = yup.object().shape({
    name: yup.string().required('Name is required').label('Name'),
    paid: yup.mixed().required("Paid is required").label('Paid'),
    yearlyLimit: yup.number()
        .required('Yearly limit is required')
        .typeError('Yearly limit must be a number')
        .min(0, 'Yearly limit cannot be negative')
        .label('Yearly Limit'),
});

const AddEditLeaveType = () => {
    const [searchParams] = useSearchParams();
    const leaveTypeId = searchParams.get("id");
    const isEdit = !!leaveTypeId;

    const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            name: '',
            paid: null,
            // yearlyLimit: 0,
        },
    });

    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const option = [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" }
    ]

    useEffect(() => {
        if (isEdit) {

            fetchLeaveTypeData();
        }
    }, [isEdit]);
    const fetchLeaveTypeData = async () => {
        setLoading(true);
        try {
            const response = await getClientUrlDataToken(
                authState.apiUrl,
                authState.userRole === 1
                    ? `${getLeaveType}?type_id=${leaveTypeId}`
                    : `${getLeaveTypeRole}?type_id=${leaveTypeId}`
            );
            if (response.status === true) {
                const leaveData = Array.isArray(response.data.data)
                    ? response.data.data[0]
                    : response.data.data;


                if (leaveData) {
                    setValue("name", leaveData.name || "");
                    setValue("paid", leaveData.paid === 1 ? { value: "yes", label: "Yes" } : { value: "no", label: "No" });
                    setValue("yearlyLimit", leaveData.yearly_limit || 0);
                }
            } else {
                toast.error(response.data?.message || "Failed to load leave type details");
            }
        } catch (error) {
            toast.error("An error occurred while loading leave type details");
        }
        setLoading(false);
    };
    const onSubmit = async (data) => {
        setLoading(true);
        const postRequest = {
            name: data.name,
            paid: data.paid?.value === "yes" ? 1 : 0,
            yearly_limit: parseInt(data.yearlyLimit, 10),
        };
        if (isEdit) {
            postRequest.type_id = leaveTypeId;
        }

        const endpoint = isEdit
            ? (authState.userRole === 1 ? updateLeaveType : updateLeaveTypeRole)
            : (authState.userRole === 1 ? storeLeaveType : storeLeaveTypeRole);

        const response = await postClientUrlWithToken(
            authState.apiUrl,
            endpoint,
            postRequest
        );

        if (response.status === 200) {
            if (response.data.status === true) {
                toast.success(response.data.message || (isEdit ? "Leave type updated successfully" : "Leave type added successfully"));
                navigate(`${process.env.PUBLIC_URL}/attendance/leave-type`);
            } else {
                if (Array.isArray(response.data.message)) {
                    response.data.message.forEach((err) => {
                        toast.error(err);
                    });
                } else {
                    toast.error(response.data.message || "An error occurred");
                }
                setLoading(false);
            }
        } else {
            HandleApiError(navigate, response.status);
        }
        setLoading(false);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs
                mainTitle={isEdit ? "Edit Leave Type" : "Add Leave Type"}
                parent="Attendance"
                title={isEdit ? "Edit Leave Type" : "Add Leave Type"}
            />
            <Card>
                <CardBody>
                    <H3>{isEdit ? "Edit Leave Type" : "Add Leave Type"}</H3>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3 p-3">
                            <Col md="6">
                                <Label className="form-label">Leave Type Name <span className="requireStar">*</span></Label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="e.g. Sick Leave, Annual Leave"
                                    {...register("name")}
                                />
                                <p className="text-danger">{errors.name?.message}</p>
                            </Col>

                            <Col md="6">
                                <Label className="form-label">Yearly Limit (Days) <span className="requireStar">*</span></Label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="e.g. 15"
                                    {...register("yearlyLimit")}
                                />
                                <p className="text-danger">{errors.yearlyLimit?.message}</p>
                            </Col>

                            <Col md="6" >
                                <Label >
                                    Paid Leave <span className="requireStar">*</span>
                                </Label>
                                <Controller
                                    name="paid"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={option}
                                            placeholder="Select "
                                            isClearable
                                            {...field}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.paid?.message}</p>

                            </Col>
                        </Row>

                        <FormGroup></FormGroup>
                        <div className="d-flex justify-content-end gap-2">
                            <Button className='btn btn-light' type="button" onClick={() => navigate(`${process.env.PUBLIC_URL}/attendance/leave-type`)}>
                                {Cancel}
                            </Button>
                            <Button type="submit">
                                {Save}
                            </Button>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default AddEditLeaveType;
